export default __webpack_public_path__ + "static/media/align-right.993683f4.svg";